import "./sass/style.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


$(function(){
  let horizontalW = 900;
  let devW = 600;

  $('.fade').scrolla({
    mobile: true, // モバイルの有効・無効
    once: true // 発火は１度だけか、視界に入るたびに発火させるか
  });

  $('.toggle').on('click', function () {
    $('.gNav_toggle').toggleClass('active');
    $('.gNav_overlay').toggleClass('open');
    $('.gNav_list').toggleClass('open');
    if ($("body").css('overflow') == 'hidden') {
      $("body").css({ overflow: 'visible' });
    } else if ($("body").css('overflow') == 'visible') {
      $("body").css({ overflow: 'hidden' });
    };
  });
  $('.gNav_list_item_link').on('click', function () {
    let winW = $(window).width();
    $('.gNav_toggle').toggleClass('active');
    $('.gNav_overlay').toggleClass('open');
    $('.gNav_list').toggleClass('open');
    if (winW < devW) {
      if ($("body").css('overflow') == 'hidden') {
        $("body").css({ overflow: 'visible' });
      } else if ($("body").css('overflow') == 'visible') {
        $("body").css({ overflow: 'hidden' });
      };
    }
  });

  if ($(".js-modal-video").length) { //クラス名js-modal-videoがあれば以下を実行
    $(".js-modal-video").modalVideo({
      channel: "youtube",
      youtube: {
        rel: 0, //関連動画の指定
        autoplay: 1, //自動再生の指定
        modestbranding : 1, // YouTubeロゴの非表示
        iv_load_policy : 3, // アノテーションの非表示
        playsinline    : 1, //インライン再生
      },
    });
  }

  $(function(){
    if($(this).scrollTop() < 1000 ) {
      $('.scrollIcon').fadeIn();
    } else {
      $('.scrollIcon').fadeOut();
    }
    $(window).scroll(function(){
      if($(this).scrollTop() < 1000 ) {
        $('.scrollIcon').fadeIn();
      } else {
        $('.scrollIcon').fadeOut();
      }
    });
  });

  $('.smoothscroll').click(function(){
    var speed = 1000;//スクロールスピード
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var adjust = -100;// 移動先を100px上にずらす
    var position = target.offset().top + adjust;
    //スムーススクロール
    $("html, body").animate({scrollTop:position}, speed, "easeOutCubic");
    return false;
  });

/* ----------------------------------
BGM switch 220124
---------------------------------- */
  const videoSP = $(".backMovie-sp").get(0);
  const videoPC = $(".backMovie-pc").get(0);
  const bgmSwitch = $(".music");
  const modalBtn = $(".js-modal-video");
  $(bgmSwitch).on("click",function(){
    let winW = $(window).width();
    if (winW < horizontalW) {
      if($(this).hasClass("is-play")){
        videoPC.muted = true;
        videoSP.muted = true;
        $(this).addClass("is-stop");
        $(this).removeClass("is-play");
      }else{
        videoPC.muted = true;
        videoSP.muted = false;
        $(this).addClass("is-play");
        $(this).removeClass("is-stop");
      }
    }else{
      if($(this).hasClass("is-play")){
        videoSP.muted = true;
        videoPC.muted = true;
        $(this).addClass("is-stop");
        $(this).removeClass("is-play");
      }else{
        videoSP.muted = true;
        videoPC.muted = false;
        $(this).addClass("is-play");
        $(this).removeClass("is-stop");
      }
    }
  });
  $(modalBtn).on("click",function(){
    let winW = $(window).width();
    if (winW < horizontalW) {
      if($(bgmSwitch).hasClass("is-play")){
        videoPC.muted = true;
        videoSP.muted = true;
        $(bgmSwitch).addClass("is-stop");
        $(bgmSwitch).removeClass("is-play");
      }
    }else{
      if($(bgmSwitch).hasClass("is-play")){
        videoSP.muted = true;
        videoPC.muted = true;
        $(bgmSwitch).addClass("is-stop");
        $(bgmSwitch).removeClass("is-play");
      }
    }
  });
});


/* ----------------------------------
ローディング
---------------------------------- */

const loading = document.getElementById('loading');
/* 読み込み完了 */
window.addEventListener('load', stopload);

/* 6秒経ったら強制的にロード画面を非表示にする */
setTimeout(stopload,10000, '');

/* ロード画面を非表示にする処理 */
function stopload(){
  loading.classList.add('is-loaded');
}


const logoTop = () => {
  const fvLogo =  document.querySelector('.logo');
  let windowHeight = window.innerHeight;
  fvLogo.style.top = (windowHeight / 2) + 'px';
}

let vw = window.innerWidth;

window.addEventListener('resize', () => {
  if (vw === window.innerWidth) {
    // 画面の横幅にサイズ変動がないので処理を終える
    return;
  }

  // 画面の横幅のサイズ変動があった時のみ高さを再計算する
  vw = window.innerWidth;
  logoTop();
});

// 初期化
logoTop();

/* ----------------------------------
BGM switch
---------------------------------- */
// const bgm = new Audio('../assets/images/spa/video/dummy.mp3');
// const play = document.querySelector('.music');
// bgm.loop = true;
//
// // 再生ボタン
// play.addEventListener('click', function(){
//   if(!bgm.paused){
//     play.classList.remove("is-play");
//     play.classList.add("is-stop");
//     bgm.pause();
//   }else{
//     play.classList.remove("is-stop");
//     play.classList.add("is-play");
//     bgm.play();
//   }
// });


/* ----------------------------------
画面高さをCSS変数に代入（100vh用）
---------------------------------- */

const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// 画面のサイズ変動があった時に高さを再計算する
window.addEventListener('resize', setFillHeight);

// 初期化
setFillHeight();

// const setFillHeight = () => {
//   const vh = window.innerHeight * 0.01;
//   document.documentElement.style.setProperty('--vh', `${vh}px`);
// }
//
// let vw = window.innerWidth;
//
// window.addEventListener('resize', () => {
//   if (vw === window.innerWidth) {
//     // 画面の横幅にサイズ変動がないので処理を終える
//     return;
//   }
//
//   // 画面の横幅のサイズ変動があった時のみ高さを再計算する
//   vw = window.innerWidth;
//   setFillHeight();
// });
//
// // 初期化
// setFillHeight();

/* ----------------------------------
スムーススクロール
---------------------------------- */
// document.addEventListener("click", e => {
//   const target = e.target;
//   // clickした要素がclass属性、smooth-scrollを含まない場合は処理を中断
//   if (!target.classList.contains("smoothscroll")) return;
//   e.preventDefault();
//   const targetId = target.hash;
//   const targetElement = document.querySelector(targetId);
//   // 画面上部から要素までの距離
//   const rectTop = targetElement.getBoundingClientRect().top;
//   // 現在のスクロール距離
//   const offsetTop = window.pageYOffset;
//   // スクロール位置に持たせるバッファ
//   const buffer = 100;
//   const top = rectTop + offsetTop - buffer;
//   console.log(top);
//
//   window.scrollTo({
//     top,
//     behavior: "smooth"
//   });
// });

gsap.to('#backMovie', {
  opacity: 0,
  scrollTrigger: {
    trigger: '.spaMovieArea',
    start: 'top 0%',
    end: 'bottom 100%', // アニメーションの終了位置の指定
    scrub: 0.5, // スクロールの進捗とアニメーションの進捗をリンクさせる
    // markers: true
  }
});

/* ----------------------------------
メニュー位置連動
---------------------------------- */

const boxes = document.querySelectorAll(".spaBox");

const options = {
  root: null, // 今回はビューポートをルート要素とする
  rootMargin: "-50% 0px", // ビューポートの中心を判定基準にする
  threshold: 0 // 閾値は0
};
const observer = new IntersectionObserver(doWhenIntersect, options);
// それぞれのboxを監視する
boxes.forEach(box => {
  observer.observe(box);
});

/**
 * 交差したときに呼び出す関数
 * @param entries
 */
function doWhenIntersect(entries) {
  // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      activateIndex(entry.target);
    }
  });
}

/**
 * 目次の色を変える関数
 * @param element
 */
function activateIndex(element) {
  // すでにアクティブになっている目次を選択
  const currentActiveIndex = document.querySelector(".gNav_list_item_link.is-current");
  // すでにアクティブになっているものが0個の時（=null）以外は、activeクラスを除去
  if (currentActiveIndex !== null) {
    currentActiveIndex.classList.remove("is-current");
  }
  // 引数で渡されたDOMが飛び先のaタグを選択し、activeクラスを付与
  const newActiveIndex = document.querySelector(`a[href='#${element.id}']`);
  newActiveIndex.classList.add("is-current");
}

/* ----------------------------------
ニュースレター登録
---------------------------------- */

$("input#formBtnSend").on('click',function(){
  // 入力されたものがメールアドレスか正規表現でチェック
  var email = document.getElementById('formEmailAddress').value;
  if (!email.match(/.+@.+\..+/)) {
    window.alert('メールアドレスを正しく入力してください');
    return;
  }

  // 多重送信を防ぐため通信完了までボタンをdisableにする
  var button = $(this);
  button.attr("disabled", true);

  // 各フィールドから値を取得してJSONデータを作成
  var data = {
    mail: email
  };

  // 通信実行
  $.ajax({
      type:"post",                // method = "POST"
      url:"https://prod-16.japaneast.logic.azure.com:443/workflows/140b3d6b18b4402985ea645aaacaf013/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=zGlFAfrbgV1YQake0s1L2quKFGeiPAnWh_ofAdWSHYo",        // POST送信先のURL
      data:JSON.stringify(data),  // JSONデータ本体
      contentType: 'application/json', // リクエストの Content-Type
      // dataType: "json",           // レスポンスをJSONとしてパースする
      success: function(json_data) {   // 200 OK時
          // 成功時処理
      },
      error: function(json_data) {         // HTTPエラー時
          alert("サーバエラーは発生しました。しばらく経ってから再度お試しください。");
      },
      complete: function() {      // 成功・失敗に関わらず通信が終了した際の処理
          button.attr("disabled", false);  // ボタンを再び enableにする
          $('.newsletter_form').addClass('newsletter_form_submitted'); // 送信完了メッセージの表示
      }
  });
});

/* ----------------------------------
スライドショー
---------------------------------- */

$(function(){
  swiper = new Swiper(".swiper", {
    infinite: true,
    autoplay: true,
    allowTouchMove: false,
    effect: 'fade',
    loop: true,
    fadeEffect: {
      crossFade: true
    },
    speed: 3000,
  });
});